import styled from 'styled-components';

const BonusList = styled.ul`
    list-style-type: none;
    padding: 0;
    margin: 0;
    font-family: 'Open Sans', sans-serif;
`;

export default BonusList;